module.exports = ".card{\n    background-color:#fff0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.css
// module id = ./src/app/about/about.component.css
// module chunks = main